import React, {Fragment} from 'react';

import {AppointmentBookingEnum} from 'main/analytics/gaTagsEnum';

import {ChangeFlowDialog} from '../ChangeFlowDialog';
import {ChangeDialogsGroupProps} from './types';
import {ChangeFlowVariantEnum} from '../ChangeFlowDialog/constants';
import {useBookingSummary} from '../../../hooks/useBookingSummary';

export function ChangeDialogsGroup({flowType, setActiveBookingFlowStep}: ChangeDialogsGroupProps) {
	const {
		changeLocationState,
		changeSpecialtyState,
		changeUnitState,
		setChangeLocationState,
		setChangeSpecialtyState,
		setChangeUnitState,
	} = useBookingSummary();

	return (
		<Fragment>
			<ChangeFlowDialog
				modalDataTagId={
					AppointmentBookingEnum.VISUALIZOU_MODAL_ALTERAR_LOCAL_DE_ATENDIMENTO
				}
				cancelModalDataTagId={
					AppointmentBookingEnum.CLICK_CANCELAR_MODAL_ALTERAR_LOCAL_DE_ATENDIMENTO
				}
				confirmModalDataTagId={
					AppointmentBookingEnum.CLICK_CONFIRMAR_MODAL_ALTERAR_LOCAL_DE_ATENDIMENTO
				}
				closeModalDataTagId={
					AppointmentBookingEnum.CLICK_FECHAR_MODAL_ALTERAR_LOCAL_DE_ATENDIMENTO
				}
				flowType={flowType}
				open={changeLocationState}
				setOpen={setChangeLocationState}
				variant={ChangeFlowVariantEnum.LOCATION}
				setActiveBookingFlowStep={setActiveBookingFlowStep}
			/>
			<ChangeFlowDialog
				modalDataTagId={AppointmentBookingEnum.VISUALIZOU_MODAL_ALTERACAO_ESPECIALIDADE}
				cancelModalDataTagId={
					AppointmentBookingEnum.CLICK_CANCELAR_MODAL_ALTERACAO_ESPECIALIDADE
				}
				confirmModalDataTagId={
					AppointmentBookingEnum.CLICK_CONFIRMAR_MODAL_ALTERACAO_ESPECIALIDADE
				}
				flowType={flowType}
				open={changeSpecialtyState}
				setOpen={setChangeSpecialtyState}
				variant={ChangeFlowVariantEnum.SPECIALTY}
				setActiveBookingFlowStep={setActiveBookingFlowStep}
			/>
			<ChangeFlowDialog
				flowType={flowType}
				open={changeUnitState}
				setOpen={setChangeUnitState}
				variant={ChangeFlowVariantEnum.UNIT}
				setActiveBookingFlowStep={setActiveBookingFlowStep}
			/>
		</Fragment>
	);
}
